import React from "react";
import { Sparkles, GraduationCap } from "lucide-react";
import { education } from "../mock";
import { Popover, PopoverContent, PopoverTrigger } from "../components/ui/popover";

function CourseworkPopover({ coursework, labelId }) {
  const [open, setOpen] = React.useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="coursework-trigger"
          aria-label="Show relevant coursework"
          aria-expanded={open}
          aria-controls={labelId}
        >
          Relevant Coursework
        </button>
      </PopoverTrigger>

      <PopoverContent
        role="dialog"
        side="top"
        align="start"
        sideOffset={10}
        collisionPadding={12}
        className="coursework-popover"
      >
        <div id={labelId}>
          <p className="coursework-popover__title">Coursework</p>
          <ul className="coursework-popover__list">
            {(coursework ?? []).map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default function Education() {
  return (
    <div className="page" style={{ paddingTop: 96 }}>
      <div
        style={{
          padding: "0 clamp(2.2rem, 6vw, 8rem)",
          maxWidth: 1100,
          margin: "0 auto",
        }}
      >
        <div className="contact-label-luxe" style={{ marginBottom: 12 }}>
          <Sparkles size={14} />
          <span>EDUCATION</span>
        </div>

        <h1
          className="contact-title-luxe"
          style={{ margin: 0, fontSize: "clamp(2.2rem, 4.8vw, 3.6rem)" }}
        >
          The foundation,
          <br />
          <span className="contact-title-gradient">and what I studied</span>
        </h1>

        <div style={{ marginTop: 26, display: "grid", gap: 18 }}>
          {education.map((e) => (
            <section
              key={e.id}
              className="pillars-scrollpin__content"
              style={{ padding: 22, position: "relative", paddingBottom: 66 }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 14,
                  flexWrap: "wrap",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <div
                    style={{
                      display: "inline-flex",
                      gap: 10,
                      alignItems: "center",
                      color: "rgba(255,182,217,0.82)",
                      fontSize: 11,
                      letterSpacing: ".28em",
                      textTransform: "uppercase",
                    }}
                  >
                    <GraduationCap size={14} />
                    {e.school}
                  </div>

                  <h2
                    style={{
                      margin: "12px 0 0",
                      fontFamily: "Playfair Display, Georgia, serif",
                      fontSize: 26,
                      lineHeight: 1.18,
                    }}
                  >
                    {e.degree}
                  </h2>

                  <div style={{ marginTop: 8, color: "rgba(255,255,255,0.60)", fontSize: 12 }}>
                    {e.location ? `${e.location} • ` : ""}
                    {e.period}
                  </div>
                </div>

                {/* keep right side clean for consistent layout */}
                <div />
              </div>

              {!!e.details?.length && (
                <div style={{ marginTop: 14, color: "rgba(255,255,255,0.80)", lineHeight: 1.9 }}>
                  {e.details.map((d) => (
                    <p key={d} style={{ margin: "8px 0" }}>
                      {d}
                    </p>
                  ))}
                </div>
              )}

              {/* coursework is shown via hover/tap popover */}

              {/* Bottom-left consistent placement across all cards */}
              <div style={{ position: "absolute", left: 22, bottom: 18 }}>
                <CourseworkPopover coursework={e.coursework} labelId={`cw-${e.id}`} />
              </div>

            </section>
          ))}
        </div>

        <div style={{ height: 80 }} />
      </div>
    </div>
  );
}

